import ExcelJS from 'exceljs';

interface ExcelColumn {
    header: string;
    key: string | number;
    width?: number;
}

interface ExcelCellValue {
    text: string | number;
    style?: {
        font?: Partial<ExcelJS.Font>,
        aligment?: Partial<ExcelJS.Alignment>,
        numFmt?: string
    };
}
type ExcelRow = Record<string, string | number | ExcelCellValue>;

interface ExcelProps {
    dataList: ExcelRow[];
    module?: string;
    title: string;
    fileName: string;
    column: ExcelColumn[];
    date?: string;
}

export const excel = (props: ExcelProps) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('sheet');
    worksheet.views = [{ showGridLines: false }];

    // MODULE
    worksheet.mergeCells(1, 1, 1, props.column.length)
    const purchaseCell = worksheet.getCell(1, 1)
    purchaseCell.value = props?.module || ""
    purchaseCell.font = { bold: true, size: 15 }
    purchaseCell.alignment = {
        vertical: "middle",
        horizontal: "center"
    }

    // TITLE
    worksheet.mergeCells(2, 1, 2, props.column.length);
    const titleCell = worksheet.getCell(2, 1);
    titleCell.value = props.title;

    titleCell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
    titleCell.font = { bold: true, size: 15 };
    worksheet.getColumn(2).width = 20

    // TGL
    if (props.date) {
        const dateCell = worksheet.getCell(3, 1);
        dateCell.value = `DATE: ${props.date}`;
        dateCell.font = { bold: true, size: 13 };
    }

    worksheet.getRow(1).height = 25;
    worksheet.getRow(2).height = 20;
    worksheet.getRow(3).height = 18;

    setWorksheetHeader({ worksheet, column: props.column });
    setWorksheetBody({ worksheet, dataList: props.dataList });

    workbook.xlsx.writeBuffer().then(buffer => {
        const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${props.fileName}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
    });
};


const setWorksheetHeader = (params: {
    worksheet: ExcelJS.Worksheet,
    column: ExcelColumn[],
}) => {
    const headerRow = params.worksheet.getRow(4);

    params.column.forEach((col, index) => {
        const cell = headerRow.getCell(index + 1);
        cell.value = col.header;
        cell.font = { size: 13, bold: true, color: { argb: 'FFFFFFFF' } };
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FF000000' },
        };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        if (col.width) {
            cell.worksheet.getColumn(index + 1).width = col.width; 
        }
    });

    headerRow.commit();
}

const setWorksheetBody = (params: {
    worksheet: ExcelJS.Worksheet,
    dataList: ExcelRow[],
}) => {
    params.dataList.forEach((rowData) => {
        const row = params.worksheet.addRow(rowData);

        Object.keys(rowData).forEach((key, colIndex) => {
            const cell = row.getCell(colIndex + 1);
            const value = rowData[key];

            if (typeof value === 'object' && value !== null && 'text' in value && 'style' in value) {
                const { text, style } = value as { text: string | number, style: ExcelJS.Style };
                cell.value = text;
                Object.assign(cell, { style });

            } else if (typeof value === 'string' || typeof value === 'number' || value instanceof Date) {
                cell.value = value;
            } else {
                cell.value = null;
            }

            cell.border = {
                top: { style: 'thin', color: { argb: 'FFCCCCCC' } },
                left: { style: 'thin', color: { argb: 'FFCCCCCC' } },
                bottom: { style: 'thin', color: { argb: 'FFCCCCCC' } },
                right: { style: 'thin', color: { argb: 'FFCCCCCC' } }
            };
        });
    });
}


